import { render } from "./Aviso.vue?vue&type=template&id=7aa0924e&scoped=true"
import script from "./Aviso.vue?vue&type=script&lang=js"
export * from "./Aviso.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=7aa0924e&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=1&id=7aa0924e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa0924e"]])

export default __exports__